import {RealTimeAPI} from 'rocket.chat.realtime.api.rxjs';

export default {
	connectToRocketChat(rocketChatRealTimeApiUrl) {
		console.log(`chat is connecting to ${rocketChatRealTimeApiUrl}`);
		return new RealTimeAPI(rocketChatRealTimeApiUrl);
	}
}